var exports = {
  "rl": "LoadingStatus__6tP9sg",
};

module.exports = exports;
